import { Link } from "@inertiajs/react"

import { ThemeMenu } from "@/components/theme-menu"

// Global site chrome. The brand doubles as the always-available "home" link —
// every page resolves through AppLayout, so this is the one guaranteed way back
// to "/" from a listing, search, or directory page. The ThemeMenu sits opposite
// the brand so theme control is reachable on every page.
export function SiteHeader() {
  return (
    <header className="border-b">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <Link href="/" className="text-lg font-bold tracking-tight hover:opacity-80">
          Africa In Touch
        </Link>
        <ThemeMenu />
      </div>
    </header>
  )
}
